// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p7Ay","toggle":"styles_toggle__2qjCj","preview":"styles_preview__1_2pe"};